import { render, staticRenderFns } from "./GettingStartedBanner.vue?vue&type=template&id=0ac220f6"
import script from "./GettingStartedBanner.vue?vue&type=script&lang=js"
export * from "./GettingStartedBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports